export default __webpack_public_path__ + "static/media/Katie_Sutherland_AHV_In_Moms_We_Trust.041b04f1.jpg";